export default __webpack_public_path__ + "static/logo-3-8686afeba33ce4b20a15a245a38ff983.webp";